import WorkpackAlertError from 'client/pages/WorkpacksPage/components/WorkpackAlerts/WorkpackAlertError/WorkpackAlertError';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import PropTypes from 'prop-types';

const WorkpackPageTitle = ({ children, className, isEmergency, error, showWarning, ...props }) => {
    return (
        <>
            { error ? <WorkpackAlertError data-testid="workpack-alert-error"/> : null}
            <h1
                className={[
                    'govuk-heading-xl govuk-!-margin-bottom-2',
                    className
                ].join(' ') }
                data-testid="workpack-page-title"
                {...props}
            >
                {children}
            </h1>
        </>
    );
};

WorkpackPageTitle.propTypes = {
    ...defaultAriaProps,
    isEmergency: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    showWarning: PropTypes.bool
};

WorkpackPageTitle.defaultProps = {
    isEmergency: false,
    showWarning: true
};

export default WorkpackPageTitle;
